export enum VenueSize {
    SMALL = "100",
    MEDIUM = "250",
    LARGE = "500",
    VERY_LARGE = "1000",
}

export const VenueSizeLabels: Record<VenueSize, string> = {
    [VenueSize.SMALL]: "328 ft - Small Venue (Classroom, cafe, small park)",
    [VenueSize.MEDIUM]: "820 ft - Medium Venue (Community hall, large park)",
    [VenueSize.LARGE]: "1,640 ft - Large Venue (Stadium, festival grounds)",
    [VenueSize.VERY_LARGE]: "3,280 ft - Very Large (Multi-venue event)",
}

